module.exports = __webpack_public_path__ + "static/full03-274d17fff1d724491eeef424b7447527.png";